import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface FormErrorMessageProps {
    message: string;
}

function FormErrorMessage({ message }: FormErrorMessageProps){
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5, pl: 0.5, pb: 2, gap: 0.5, maxWidth: '220px' }}>
            <ErrorOutlineIcon sx={{ color: 'error.main', fontSize: '1rem' }} />
            <Typography variant="body2" sx={{ color: 'text.primary'}}>
                {message}
            </Typography>
        </Box>
    );
};

export default FormErrorMessage;
